// @spec VUL-STR-041
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { VulnerabilityDashboard } from '@/features/vulnerabilities/dashboard';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.vulnerabilityDashboard'),
  }),
  component: VulnerabilityDashboardPage,
});

/**
 * Vulnerability dashboard page providing a comprehensive overview of
 * the organization's vulnerability posture.
 *
 * Features:
 * - Summary cards showing total and severity-wise vulnerability counts
 * - SLA compliance metrics with on-track/at-risk/overdue breakdown
 * - CISA KEV compliance status
 * - Severity and status distribution charts
 * - Trending metrics (new/closed this week/month)
 * - Mean Time To Remediate (MTTR) metrics
 * - Top vulnerable assets table
 * - Acceptance/exception metrics
 * - Date range and category filters
 * - Auto-refresh every 5 seconds
 */
function VulnerabilityDashboardPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        {/* Header */}
        <header>
          <h1 className="text-3xl font-semibold text-foreground">Vulnerability Dashboard</h1>
          <p className="mt-1 text-muted-foreground">
            Overview of your organization&apos;s vulnerability posture
          </p>
        </header>

        {/* Dashboard Content */}
        <VulnerabilityDashboard />
      </div>
    </div>
  );
}
